import { IDateOption } from "src/app/search/models/date-option.interface";
import * as moment from "moment";
import { CreateDateFilter } from "src/app/application/applications.component";

export class TodayAuditLog implements IDateOption {
  todayMidnight = moment().startOf('day');
  option = "Today";
  dateFilter: CreateDateFilter

  constructor() {
    this.dateFilter = new CreateDateFilter(this.option, this.todayMidnight);
    this.dateFilter.DATE_FIELD = "createdDate";
    this.dateFilter.buildFilter();
  }

  get query(): string {
    return this.dateFilter.filterString!;
  }
}
